// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.fans-list-container {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  float: left;
  margin: 0 20px 20px 0;
  min-height: 550px !important;
  padding: 20px;
  padding-bottom: 50px;
  position: relative;
  display: block;
  width: calc(33.33% - 14px);
}
.fans-list-container .tileHeader {
  font: 18px "Omnes-ATT-W02-Medium";
  margin-bottom: 0px !important;
}
.fans-list-container header {
  margin-bottom: 20px;
}
.fans-list-container .systemFailure {
  margin: 0;
}
.fans-list-container .systemFailure .alert-icon {
  width: 20px;
  float: left;
  margin-right: 10px;
}
.fans-list-container .systemFailure .extra-content {
  float: left;
  width: 80%;
}
.fans-list-container .systemFailure .icon-alert {
  width: 20px;
  height: 20px;
  color: #ffb81c;
}
.fans-list-container footer {
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  background-color: hsl(0, 0%, 95%);
  border-top: 1px solid #d2d2d2;
  bottom: 0;
  margin-left: -20px;
  padding: 20px;
  position: absolute;
  width: 100%;
}
.fans-list-container .btn, .fans-list-container .btn-default {
  width: 100%;
}
.fans-list-container .deviceStatus {
  min-height: 138px !important;
}
.fans-list-container .legend {
  padding-bottom: 30px;
  font-size: 14px;
}
.fans-list-container .staus {
  padding-bottom: 20px;
  font-size: 14px;
}

.disable-link {
  pointer-events: none !important;
  color: #707070;
}

.tablenew1 {
  margin-left: -10px;
  min-height: 123px;
  width: 114% !important;
}
.tablenew1 tr, .tablenew1 th, .tablenew1 td {
  border: 0;
  padding-right: 0px;
}

.tableoem tr td {
  padding-top: 5px !important;
}

.tablenew {
  margin-left: -10px;
  width: 120% !important;
}
.tablenew tr, .tablenew th, .tablenew td {
  border: 0;
  padding-right: 15px;
}

.tableoem tr td {
  padding-top: 5px !important;
}

.inventory-label {
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 16px;
  max-width: 215px !important;
}

@media (max-width: 1024px) {
  .fans-list-container {
    float: none;
    min-height: auto;
    width: 100%;
  }
  .fans-list-container footer {
    margin: 0 -20px -20px;
    position: relative;
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-inventory/device-summary/device-summary.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EFiCI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EE/BF,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAsJF;AApJE;EACE,iCAAA;EACA,6BAAA;AAsJJ;AAnJE;EACE,mBAAA;AAqJJ;AAlJE;EACE,SAAA;AAoJJ;AAlJI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAoJN;AAjJI;EACE,WAAA;EACA,UAAA;AAmJN;AAhJI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAkJN;AA7IE;EFXE,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEaA,iCAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAmJJ;AA/IE;EACE,WAAA;AAiJJ;AA9IE;EACE,4BAAA;AAgJJ;AA7IE;EACE,oBAAA;EACA,eAAA;AA+IJ;AA5IE;EACE,oBAAA;EACA,eAAA;AA8IJ;;AA1IA;EACE,+BAAA;EACA,cAAA;AA6IF;;AA1IA;EACE,kBAAA;EACA,iBAAA;EAKA,sBAAA;AAyIF;AA7IE;EACE,SAAA;EACA,kBAAA;AA+IJ;;AA1IE;EACE,2BAAA;AA6IJ;;AAzIA;EACE,kBAAA;EAMA,sBAAA;AAuIF;AA5IE;EACE,SAAA;EACA,mBAAA;AA8IJ;;AAxIE;EACE,2BAAA;AA2IJ;;AAvIA;EACE,mCAAA;EACA,eAAA;EACA,2BAAA;AA0IF;;AFtOI;EEoGF;IACE,WAAA;IACA,gBAAA;IACA,WAAA;EAsIF;EApIE;IACE,qBAAA;IACA,kBAAA;IACA,WAAA;EAsIJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.fans-list-container {\n  @include vendor-prefix('border-radius', 8px);\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  float: left;\n  margin: 0 20px 20px 0;\n  min-height: 550px !important;\n  padding: 20px;\n  padding-bottom: 50px;\n  position: relative;\n  display: block;\n  width: calc(33.33% - 14px);\n\n  .tileHeader {\n    font: 18px 'Omnes-ATT-W02-Medium';\n    margin-bottom: 0px !important;\n  }\n\n  header {\n    margin-bottom: 20px;\n  }\n\n  .systemFailure {\n    margin: 0;\n\n    .alert-icon {\n      width: 20px;\n      float: left;\n      margin-right: 10px;\n    }\n\n    .extra-content {\n      float: left;\n      width: 80%;\n    }\n\n    .icon-alert {\n      width: 20px;\n      height: 20px;\n      color: #ffb81c;\n    }\n  }\n  \n\n  footer {\n    @include vendor-prefix('border-radius', 0 0 8px 8px);\n    background-color: color(default, base);\n    border-top: 1px solid color(default, dark);\n    bottom: 0;\n    margin-left: -20px;\n    padding: 20px;\n    position: absolute;\n    width: 100%;\n\n  }\n\n  .btn, .btn-default {\n    width: 100%;\n  }\n\n  .deviceStatus{\n    min-height: 138px !important;\n  }\n\n  .legend {\n    padding-bottom: 30px;\n    font-size: 14px;\n    // min-height: 74px;\n  }\n  .staus {\n    padding-bottom: 20px;\n    font-size: 14px;\n  }\n}\n\n.disable-link{\n  pointer-events: none !important;\n  color: #707070;\n}\n\n.tablenew1 {\n  margin-left: -10px;\n  min-height: 123px;\n  tr,th,td {\n    border:0 ;\n    padding-right: 0px;\n  } \n  width: 114% !important;\n}\n.tableoem{\n  tr td{\n    padding-top: 5px !important;\n  }\n\n}\n.tablenew {\n  margin-left: -10px;\n  tr,th,td {\n    border:0 ;\n    padding-right: 15px;\n    //padding-right: 20px;\n  } \n  width: 120% !important;\n}\n.tableoem{\n  tr td{\n    padding-top: 5px !important;\n  }\n\n}\n.inventory-label{\n  font-family: 'Omnes-ATT-W02-Medium';\n  font-size: 16px;\n  max-width: 215px !important;\n }\n\n//  .notification-label{\n//   min-width: 215px !important;\n//  }\n\n@include respond-to(small) {\n  .fans-list-container {\n    float: none;\n    min-height: auto;\n    width: 100%;\n\n    footer {\n      margin: 0 -20px -20px;\n      position: relative;\n      width: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
